import { Outlet } from 'react-router';
import { ResidentSidebar } from '../components/resident/sidebar';
import { clearToken, clearRefreshToken } from '../lib/auth';
import { useNavigate } from 'react-router';

export function DashboardLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearToken();
    clearRefreshToken();
    navigate('/login');
  };

  return (
    <div className="flex h-screen">
      <ResidentSidebar onLogout={handleLogout} />
      <main className="flex-1 overflow-auto p-8">
        <Outlet />
      </main>
    </div>
  );
}
